// src/constants/countries.js
import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(en);

const COUNTRIES = Object.entries(countries.getNames('en'))
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name));

const UK = COUNTRIES.find((country) => country.code === 'GB');
export const COUNTRIES_WITH_UK_FIRST = [
  UK,
  ...COUNTRIES.filter((country) => country.code !== 'GB'),
];
